// Based on https://stackoverflow.com/a/48550430
import { widgetInitialisation } from "../functions/widget-init";
import { NumberUtils } from "../functions/number-utils";

widgetInitialisation(initToCurrencyFilter);
widgetInitialisation(initToCurrencyNoCentsFilter);

function initToCurrencyFilter() {
    Vue.filter('toCurrency', function (value, options) {
        options = options || {};

        var minimumFractionDigits = '2';
        if (typeof options.minimumFractionDigits === "number") {
            minimumFractionDigits = options.minimumFractionDigits.toString();
        }

        if (typeof value !== "number") {
            var parsedValue = NumberUtils.tryParse(value);
            if (parsedValue === null)
                return value;

            value = parsedValue;
        }

        var currencyCode = options.currencyCode || 'USD';

        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: minimumFractionDigits
        });

        return formatter.format(value);
    });
}

function initToCurrencyNoCentsFilter() {
    Vue.filter('toCurrencyNoCents', function (value, options) {
        options = options || {};

        var minimumFractionDigits = '0';
        if (typeof options.minimumFractionDigits === "number") {
            minimumFractionDigits = options.minimumFractionDigits.toString();
        }

        if (typeof value !== "number") {
            var parsedValue = NumberUtils.tryParse(value);
            if (parsedValue === null)
                return value;

            value = parsedValue;
        }

        var currencyCode = options.currencyCode || 'USD';

        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: minimumFractionDigits
        });

        return formatter.format(parseInt(value,10));
    });
}